import BugsnagPerformance from '@bugsnag/browser-performance';

import { PERFORMANCE_CONFIG } from '../constants';

const { apiKey, appVersion, releaseStage, enabledReleaseStages } = PERFORMANCE_CONFIG;

BugsnagPerformance.start({
    apiKey,
    appVersion,
    releaseStage,
    enabledReleaseStages,
});

export default BugsnagPerformance;
